module.exports = __webpack_public_path__ + "c53bdf5a8afb4ad28798241cd7ead5c9.svg";